import React from "react";
import {
  DialogContainer,
  AlertDialog,
} from "@adobe/react-spectrum";

interface CancelConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CancelConfirmationDialog: React.FC<CancelConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <DialogContainer onDismiss={onClose}>
      <AlertDialog
        variant="confirmation"
        title="Cancel Callback"
        primaryActionLabel="Confirm"
        cancelLabel="Cancel"
        onPrimaryAction={handleConfirm}
        onCancel={handleCancel}
      >
        Are you sure you want to cancel this callback?
      </AlertDialog>
    </DialogContainer>
  );
};

export default CancelConfirmationDialog;
